import { ServiceArticlePage } from "@/components/ServiceArticlePage";
import { SERVICES } from "@/data/content";
import { BUSINESS_MANAGEMENT_ARTICLE } from "@/data/businessManagement";

const service = SERVICES.find((s) => s.slug === "business-management");

export default function BusinessManagement() {
  return (
    <ServiceArticlePage
      service={service}
      blocks={BUSINESS_MANAGEMENT_ARTICLE}
      overline="Service guide — III"
      lede="Process consulting, operations support, workflow planning, documentation and organisation, digital setup assistance and website/content coordination — what each involves and how an engagement works."
      seoDescription="Business management services from My Geeks LLC: process consulting, operations support, workflow planning, documentation, digital business setup and website/content coordination."
    />
  );
}
